import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"friendZoneButton"},[_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c(VBtn,_vm._g(_vm._b({attrs:{"color":"secondary","icon":""},on:{"click":_vm.goToFriendZone}},'v-btn',attrs,false),on),[_c('font-awesome-icon',{staticClass:"fa-lg",attrs:{"icon":_vm.icon.friends}})],1)]}}])},[_c('span',[_vm._v("Zone des amis")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }